import _ from '@lodash';
import * as Actions from '../Actions/MensagemActions';

const initialState = {
    mensagens: [],
    participantes: [],
    info: null,
    warning: null,
    error: null,
};

const MensagemReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_MENSAGEM:
            {
                return {
                    ...state,
                    mensagens: !_.isUndefined(action.mensagens) && !_.isNull(action.mensagens) ? action.mensagens : [],
                    participantes: !_.isUndefined(action.participantes) && !_.isNull(action.participantes) ? action.participantes : [],
                };
            }
        case Actions.MENSAGEM_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.MENSAGEM_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.MENSAGEM_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = MensagemReducer
export default reducer;
